import { api } from "api";
import { useMutation, useQuery } from "@tanstack/react-query";
import { T_Api_Paginated, T_Api_Success_Res } from "./api.types";
import { EventDto, EventTimeFrame } from "dtos/events.dto";
import { ParticipantDto } from "dtos/participant.dto";

export const eventService = {
  useGetPaginated: (params: { page: number; limit: number; timeMode?: EventTimeFrame }) => {
    return useQuery({
      queryKey: ["events", "all", params],
      queryFn: async () => {
        const res = await api.get(
          `/event?page=${params.page}&limit=${params.limit}${params.timeMode ? `&timeMode=${params.timeMode}` : ""}`,
        );
        return res.data as T_Api_Success_Res<T_Api_Paginated<EventDto>>;
      },
    });
  },

  useRegisterParticipant: () => {
    return useMutation({
      mutationKey: ["events/participant", "register-participant"],
      mutationFn: async (body: ParticipantDto) => {
        const res = await api.post("/participant", body);

        return res.data as T_Api_Success_Res<{
          participant: ParticipantDto;
          sendPaymentPrompt: boolean;
          paymentUrl: string;
        }>;
      },
    });
  },

  useGetById: (id: string | undefined) => {
    return useQuery({
      queryKey: ["events", id],
      queryFn: async () => {
        const res = await api.get(`/event/${id}`);
        return res.data as T_Api_Success_Res<EventDto>;
      },
      enabled: !!id,
    });
  },

  useGetParticipantsPaginated: (params: { page: number; limit: number; time: string; eventId: string }) => {
    return useQuery({
      queryKey: ["participant", "all", params],
      queryFn: async () => {
        const res = await api.get(
          `/participant/${params.eventId}?page=${params.page}&limit=${params.limit}&time=${params.time}`,
        );
        return res.data as T_Api_Success_Res<T_Api_Paginated<ParticipantDto>>;
      },
    });
  },
};
